<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    open: {
        default: false,
        type: Boolean,
    },
});

const emit = defineEmits(['closeModal']);

const show = computed({
    get() {
        return props.open;
    },
    set(value) {
        emit('closeModal', value);
    },
});
</script>

<template>
    <BaseModal
        v-model:show="show"
        width="lg:!max-w-[800px]"
        center
        title="Ansprechperson"
    >
        <div class="mt-2 px-6 text-center md:px-10">
            <ContactPerson />
        </div>
    </BaseModal>
</template>
